<ul   class="pratiche">
  <li
    *ngFor="let pratica of pratiche; let i = index"
    class="panel">
    <div *ngIf="pratica.archiviata || !pratica.archiviata">
      <div class="{{'pratica ' + getClassPratica(pratica.tipoPratica.id)}}">
        <div>
          <p
            [className]="'categoria '+getClassPratica(pratica.tipoPratica.id)">{{pratica.intestazione.campi.tipoPratica | tipoPraticaPipe}}</p>
          <p class="codice">{{pratica.intestazione.campi.posizionePratica}}</p>
        </div>
        <div>
          <p class="identificativo">
            <ng-container>{{(pratica.intestazione.campi.societa ?
              pratica.intestazione.campi.societa + ' - ' : '')}}</ng-container>
            {{(pratica.intestazione.campi.dataAperturaPratica ? (' DEL ' + (pratica.intestazione.campi.dataAperturaPratica |
            date:'dd/MM/yyyy')): (pratica.intestazione.campi.dataApertura ? (' DEL ' + (pratica.intestazione.campi.dataApertura |
            date:'dd/MM/yyyy')): '')) + (pratica.definito ? ' DEFINITA' : '')
          + ((pratica.definito && pratica.dataDefinizione) ? ' IL ' +
            (pratica.dataDefinizione | date:'dd/MM/yyyy') : '')}} &nbsp;
            <ng-container *ngIf="pratica.intestazione.campi.numeroSinistro && hasFascicoloSanitario(pratica)">{{ ' - N° sinistro ' + pratica.intestazione.campi.numeroSinistro }}</ng-container>
            <span *ngIf="pratica.definito" title="Definita"
                  class="glyphicon glyphicon-lock"></span>
            <span *ngIf="pratica.correlata" title="Correlata"
                  class="glyphicon glyphicon-link"></span>
            <span *ngIf="pratica.capofila" title="Capofila riunione di giudizi"
                  class="riunionegiudizi glyphicon glyphicon-resize-small"><span
              class="glyphicon capofila">C</span></span>
            <span *ngIf="pratica.riunita" title="Riunione di giudizi"
                  class="glyphicon glyphicon-resize-small"></span>
            <span *ngIf="pratica.archiviata" title="Archiviata"
                  class="glyphicon glyphicon-floppy-saved"></span>
          </p>

            <h4 class="titolo row">
              <a [routerLink]="['/' + getPraticaPath(pratica.tipoPratica.id), pratica.id]"
                class="col-sm-7">
                {{pratica.intestazione.campi.contropartePrimaria ?
                pratica.intestazione.campi.contropartePrimaria + " - " :
                "Nessun soggetto/parte specificato " + " - " }} {{
                pratica.intestazione.campi.materia ?
                pratica.intestazione.campi.materia + "/" : ""}} {{
                pratica.intestazione.campi.oggetto ?
                pratica.intestazione.campi.oggetto : "" }} </a>
              <button class="btn btn-primary col" (click)="createFascicolo(i)">
                <span style="margin-left: -4px;" class="glyphicon glyphicon-plus"></span>
                Crea fascicolo
              </button>
            </h4>


          <ng-template [ngIf]="pratica.intestazione.campi.testoDiEvidenza">
            <p class="descrizione">{{pratica.intestazione.campi.testoDiEvidenza}}</p>
          </ng-template>
        </div>
        <button class="btn btn-show-fascicolo" (click)="showFascicolo(i)">
          <span [ngClass]="isShowFascicolo[i] ?
            'glyphicon glyphicon-menu-up' : 'glyphicon glyphicon-menu-down'">
          </span>
        </button>
      </div>
      <div *ngIf="isShowFascicolo[i]">
        <ul *ngIf="pratica.fascicoliLight && pratica.fascicoliLight.length > 0">
          <li *ngFor="let fascicolo of pratica.fascicoliLight | orderBy:'intestazione.campi.posizione:DESC'; let j = index">
            <div
              class="{{'subpratica ' + (getCssClassCategoriaFascicolo(fascicolo)) + (!fascicolo.visible ? ' disabled' : '') }}">
              <div>
                <p class="{{'categoria ' + fascicolo?.intestazione.campi.tipoFascicolo.toLowerCase()}}">
                  {{ fascicolo?.intestazione.campi.tipoFascicolo}}</p>
                <p class="codice">{{ fascicolo?.intestazione.campi.posizione}}</p>
              </div>
              <div>
                <p class="identificativo">
                  {{fascicolo.intestazione.campi.numeroRuolo ? 'N. ruolo '+fascicolo.intestazione.campi.numeroRuolo+' ' :
                  ''}}
                  {{ 'DEL ' + (fascicolo.intestazione.campi.dataInizioFascicolo |
                  date:'dd/MM/yyyy') }}
                  {{ fascicolo.intestazione.campi.definito ?
                  ' - DEFINITA IL ' +
                  (fascicolo.intestazione.campi.dataDefinizione |
                    date:'dd/MM/yyyy') : '' }}
                  {{(fascicolo.intestazione.campi.tipoRicorso) ? (' - '+fascicolo.intestazione.campi.tipoRicorso) : ''}}
                  {{(fascicolo.intestazione.campi.tipoOpposizione) ? (' - '+fascicolo.intestazione.campi.tipoOpposizione) : ''}}
                  <span
                    *ngIf="fascicolo.intestazione.campi.definito" title="Definito"
                    class="glyphicon glyphicon-lock"></span> <span
                  *ngIf="fascicolo.intestazione.campi.capofila"
                  title="Capofila riunione di giudizi"
                  class="riunionegiudizi glyphicon glyphicon-resize-small"><span
                  class="glyphicon capofila">C</span></span> <span
                  *ngIf="fascicolo.intestazione.campi.riunito"
                  title="Riunione di giudizi"
                  class="glyphicon glyphicon-resize-small"></span> <span
                  *ngIf="pratica.archiviata" title="Archiviato"
                  class="glyphicon glyphicon-floppy-saved"></span>
                  <span *ngIf="fascicolo.intestazione.campi.isDocumentazione" class="glyphicon glyphicon-file" title="Documenti allegati"></span>
                </p>
                  <h5 class="titolo row">
                    <a [routerLink]="['/' + getFascicoloPath(pratica, fascicolo), fascicolo.id]"
                      class="col-sm-6" *ngIf="fascicolo.visible">
                      {{fascicolo.intestazione.campi.contropartePrimaria ?
                      fascicolo.intestazione.campi.contropartePrimaria :
                      "Nessun soggetto/parte specificato " }}
                      <ng-container>{{
                        fascicolo.intestazione.campi.grado ?
                        " - " + fascicolo.intestazione.campi.grado : "" }}
                      </ng-container>
                      {{fascicolo?.intestazione.campi.natura ? " - " +
                          fascicolo?.intestazione.campi.natura : ""}}
                    </a>
                    <span class="col-sm-6" *ngIf="!fascicolo.visible">
                      <ng-container>
                        {{fascicolo.intestazione.campi.contropartePrimaria ?
                        fascicolo.intestazione.campi.contropartePrimaria :
                        "Nessun soggetto/parte specificato " }}
                      </ng-container>
                      <ng-container> {{
                        fascicolo.intestazione.campi.grado ?
                        " - " + fascicolo.intestazione.campi.grado : "" }} </ng-container>
                        {{fascicolo?.intestazione.campi.natura ? " - " +
                        fascicolo?.intestazione.campi.natura : ""}}
                    </span>
                    <button *ngIf="!buttonAssociaHide" class="btn btn-primary col" type="button" (click)="associaFascicolo(i, j)">
                      <span style="margin-left: -4px;" class="glyphicon glyphicon-new-window"></span>
                      Associa
                    </button>
                  </h5>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </li>
</ul>
